export default "__VITE_ASSET__Bqo6Otw4__"